import { render, staticRenderFns } from "./WorkBench.vue?vue&type=template&id=9d541f2e&scoped=true&lang=html"
import script from "./WorkBench.vue?vue&type=script&lang=js"
export * from "./WorkBench.vue?vue&type=script&lang=js"
import style0 from "./WorkBench.vue?vue&type=style&index=0&id=9d541f2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d541f2e",
  null
  
)

export default component.exports